import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("rz_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const setToken = (t) => localStorage.setItem("rz_token", t);
export const clearToken = () => localStorage.removeItem("rz_token");
export const getToken = () => localStorage.getItem("rz_token");

// Resolve an image value to a usable src: storage paths (/api/img/..) get the backend host,
// data URLs / http URLs / frontend static paths (/photos/..) are returned unchanged.
export function imgUrl(v) {
  if (!v || typeof v !== "string") return v;
  if (v.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${v}`;
  return v;
}

// Upload an image file to object storage; returns the stored URL path.
export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data.url;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
